<template>
  <!-- Изменение статуса проекта-->
  <div class="modal fade in show" tabindex="-1" role="dialog">
    <form v-on:submit.prevent="setNewStatus">
      <div class="modal-dialog modal-new-style" role="document">
        <div class="modal-content modal-content-middle">
          <div class="modal-header">
            <button type="button" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Статус заявки</h4>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger"
              role="alert"
              v-for="err in saveErrors"
            >
              {{ err }}
            </div>
            <div class="form-group">
              <label>Статус</label>
              <select
                class="form-control"
                v-model="statusData.UF_STATUS_ID"
                @change="checkNewStatus"
              >
                <option></option>
                <option
                  v-for="item in statuses"
                  v-bind:key="item.ID"
                  v-bind:value="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>
            <div class="form-group" v-if="nextStatusData.IS_CHANGE_MANAGER">
              <label v-if="hasManager">Назначить менеджера</label>
              <label v-else>Прикрепить менеджера</label>
              <select class="form-control" v-model="statusData.UF_MANAGER_ID">
                <option
                  v-for="item in managerList"
                  v-bind:key="item.ID"
                  v-bind:value="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>
            <div
              class="form-group"
              v-if="nextStatusData.IS_SET_DEPARTAMENT_PROJECT"
            >
              <label>Ответственный департамент</label>
              <select
                class="form-control"
                v-model="statusData.UF_DEPARTAMENT_FIE_ID"
              >
                <option
                  v-for="item in directory.sp_departament_project"
                  v-if="item.IS_VIEW_CHANGE_STATUS == 1"
                  v-bind:key="item.ID"
                  v-bind:value="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>

            <div class="form-group" v-if="nextStatusData.STOP_WORK_COM">
              <label>Причина приостановки работы</label>
              <select
                class="form-control"
                v-model="statusData.UF_STOP_WORK_COM_ID"
              >
                <option
                  v-for="item in directory.type_suspension_sp"
                  v-bind:key="item.ID"
                  v-bind:value="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>

            <div class="form-group" v-if="nextStatusData.TERMINATED_WORK_COM">
              <label>Причина прекращения работы</label>
              <select
                class="form-control"
                v-model="statusData.UF_TERM_WORK_COM_ID"
              >
                <option
                  v-for="item in directory.type_terminate_sp"
                  v-bind:key="item.ID"
                  v-bind:value="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>

            <div class="form-group" v-if="nextStatusData.IS_LOAD_FILE">
              <label>{{ nextStatusData.NAME_FILE }}</label>
              <div>
                <div style="display: inline-block">
                  <input
                    type="file"
                    ref="file"
                    @change="onChange"
                    accept=".pdf"
                    style="display: none"
                  />
                  <button
                    type="button"
                    @click="$refs.file.click()"
                    class="btn btn-default"
                  >
                    Загрузить файл
                  </button>
                </div>
                <div style="display: inline-block">
                  &nbsp;&nbsp;&nbsp;{{ uFile }}
                </div>
              </div>
            </div>

            <div class="form-group" v-if="nextStatusData.IS_SET_SUM_APPROVED">
              <label> Одобренная сумма, тыс. руб.<span>*</span></label>
              <vue-numeric
                currency=""
                separator="space"
                output-type="Number"
                type="text"
                class="form-control i-main-style"
                v-model="sumApproved"
              />
            </div>

            <div class="form-group" v-if="nextStatusData.IS_SET_COMMET">
              <label
                >{{ nextStatusData.LABEL_COMMENT
                }}<span v-if="nextStatusData.IS_REQ_COMMENT" style="color:red;"
                  >*</span
                ></label
              >
              <textarea
                class="form-control stl-textarea-rn"
                v-model="statusData.UF_COMMENT_STATUS_M"
              >
              </textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="butt-stl butt-black"
              data-dismiss="modal"
              v-on:click="$parent.showChangeStatusDialog = false"
            >
              отменить
            </button>
            <button
              type="submit"
              class="butt-stl butt-blue"
              v-if="showSubmitBtn"
              :disabled="!isReadyToSend || isSendForm"
            >
              Сохранить
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </form>
  </div>
  <!-- /.modal -->
  <!-- Изменение статуса проекта -->
</template>

<script>
import { FETCH_DIRECTORIES, FETCH_PROJECT_HISTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { ProjectsService } from "@/common/api.service";

export default {
  data() {
    return {
      saveErrors: [],
      hasManager: "",
      statuses: [],
      uFile: "",
      statusData: {
        UF_STATUS_ID: "",
        UF_MANAGER_ID: "",
        UF_FILE_NOTICE: "",
        UF_COMMENT_STATUS_M: "",
        UF_STOP_WORK_COM_ID: 0,
        UF_TERM_WORK_COM_ID: 0
      },
      nextStatusData: {
        ALL_STATUS_ID: [],
        BP_ID: 0,
        ID: 0,
        IS_CHANGE_MANAGER: 0,
        IS_LOAD_FILE: 0,
        IS_SET_COMMET: 0,
        IS_REQ_COMMENT: false,
        NAME: "",
        NAME_FILE: "",
        LABEL_COMMENT: "",
        STOP_WORK_COM: false,
        TERMINATED_WORK_COM: false
      },
      showSubmitBtn: false,
      step: 1,
      sumApproved: 0,
      isSendForm: false
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "source_information",
      "program_fin_support",
      "status_all",
      "type_suspension_sp",
      "type_terminate_sp",
      "sp_departament_project"
    ]);

    this.directory.program_fin_support.forEach(async function(s) {
      console.log(s);
      this.showSubmitBtn = false;
      if (s.ID === this.$parent.project.UF_SUPPORT_PROG_ID) {
        this.statuses = [];
        ProjectsService.bpStatus(
          s.UF_BP_ID,
          this.$parent.project.UF_STATUS_ID
        ).then(({ data }) => {
          if (this.$parent.documentConf) {
            if (
              //this.$parent.documentConf.FILE_ACCEPT_INFO.FACT_ACCEPT ===
              // this.$parent.documentConf.FILE_ACCEPT_INFO.NEED_ACCEPT &&
              this.$parent.documentConf.FILE_ACCEPT_INFO.FACT_ACCEPT ===
              this.$parent.documentConf.FILE_ACCEPT_INFO.FACT_ACCEPT_YES
            ) {
              Object.keys(data[0].NEXT_STATUS_ID).forEach(function(k) {
                this.directory.status_all.forEach(function(item) {
                  if (item.ID === data[0].NEXT_STATUS_ID[k]) {
                    this.statuses.push(item);
                  }
                }, this);
              }, this);
            } else {
              if (data[0].FIND_IS_NEXT_STATUS) {
                Object.keys(data[0].NEXT_STATUS_ID).forEach(function(k) {
                  this.directory.status_all.forEach(function(item) {
                    if (item.ID === data[0].NEXT_STATUS_ID[k]) {
                      this.statuses.push(item);
                    }
                  }, this);
                }, this);
              } else {
                Object.keys(data[0].PREV_STATUS_ID).forEach(function(k) {
                  this.directory.status_all.forEach(function(item) {
                    if (item.ID === data[0].PREV_STATUS_ID[k]) {
                      this.statuses.push(item);
                    }
                  }, this);
                }, this);
              }

              Object.keys(data[0].NEXT_STATUS_ID).forEach(function(k) {
                this.directory.status_all.forEach(function(item) {
                  if (
                    item.CODE === "stop_work" &&
                    item.ID === data[0].NEXT_STATUS_ID[k]
                  ) {
                    this.statuses.push(item);
                  }
                }, this);
              }, this);
            }
          } else {
            Object.keys(data[0].ALL_STATUS_ID).forEach(function(k) {
              this.directory.status_all.forEach(function(item) {
                if (item.ID === data[0].ALL_STATUS_ID[k]) {
                  this.statuses.push(item);
                }
              }, this);
            }, this);
          }
          if (this.getStatus(this.project.UF_STATUS_ID).CODE === "stop_work") {
            this.$store.dispatch(FETCH_PROJECT_HISTORY).then(() => {
              this.directory.status_all.forEach(function(item) {
                if (
                  item.ID ===
                  this.projectStatusHistory[
                    this.projectStatusHistory.length - 1
                  ].UF_PREV_ST_ID
                ) {
                  if (
                    item.CODE === "approved_expert_sovet" ||
                    item.CODE === "approved_watcher_sovet"
                  ) {
                    this.directory.status_all.forEach(function(item) {
                      if (item.CODE === "complex_expertise") {
                        if (this.currentUser.ACTIVE_ROLE_CODE === "admin") {
                          this.statuses.push(item);
                        }
                      }
                    }, this);
                  }
                  if (item.CODE === "signed_dogovor_zaim") {
                    this.directory.status_all.forEach(function(item) {
                      if (
                        s.CODE !== "epidemiological_control" &&
                        item.CODE === "complex_expertise"
                      ) {
                        if (this.currentUser.ACTIVE_ROLE_CODE === "admin") {
                          this.statuses.push(item);
                        }
                      }
                      if (
                        s.CODE === "epidemiological_control" &&
                        item.CODE === "eligibility_assessment"
                      ) {
                        if (item.CODE === "complex_expertise") {
                          if (this.currentUser.ACTIVE_ROLE_CODE === "admin") {
                            this.statuses.push(item);
                          }
                        }
                      }
                    }, this);
                  }

                  this.statuses.push(item);
                  ProjectsService.bpStatus(s.UF_BP_ID, item.ID).then(
                    ({ data }) => {
                      this.directory.status_all.forEach(function(stItem) {
                        data[0].ALL_STATUS_ID.forEach(function(stId) {
                          if (
                            stId === stItem.ID &&
                            stItem.CODE === "org_cansel_zaim"
                          ) {
                            this.statuses.push(stItem);
                          }
                        }, this);
                      }, this);
                    },
                    this
                  );
                }
              }, this);
            });
          }
        }, this);
      }
      this.showSubmitBtn = true;
    }, this);
    this.hasManager = this.$parent.project.UF_MANAGER_ID > 0;
    this.statusData.UF_MANAGER_ID = this.$parent.project.UF_MANAGER_ID;

    if (this.statusData.UF_SUM_APPROVED == null) {
      if (this.$parent.project.OTHER_SOURCE_FINANCE.summZaimOnlyFond) {
        this.statusData.UF_SUM_APPROVED =
          this.$parent.project.OTHER_SOURCE_FINANCE.summZaimOnlyFond * 1000;
      } else {
        this.statusData.UF_SUM_APPROVED =
          this.$parent.project.UF_SUM_REQUEST * 1000;
      }
    }

    this.sumApproved = this.statusData.UF_SUM_APPROVED;

    if (this.$parent.project.META.DEF_TYPE_DEPARTAMENT_PROJECT_ID > 0) {
      this.statusData.UF_DEPARTAMENT_FIE_ID = this.$parent.project.META.DEF_TYPE_DEPARTAMENT_PROJECT_ID;
    }

    console.log("this.$parent.project: ", this.$parent.project);
    console.log("statuses ", this.statuses);
  },
  asyncComputed: {
    async managerList() {
      let list = [];
      this.showSubmitBtn = false;
      await ProjectsService.getListManagerProject().then(({ data }) => {
        data.forEach(function(d) {
          list.push({
            ID: d.ID,
            NAME: d.LAST_NAME + " " + d.NAME + " " + d.SECOND_NAME
          });
        });
      }, this);
      this.showSubmitBtn = true;
      return list;
    }
  },
  computed: {
    isReadyToSend() {
      if (!this.statusData.UF_STATUS_ID) {
        return false;
      }
      if (
        this.nextStatusData.IS_CHANGE_MANAGER &&
        !this.statusData.UF_MANAGER_ID
      ) {
        return false;
      }
      if (
        this.nextStatusData.IS_REQ_COMMENT &&
        !this.statusData.UF_COMMENT_STATUS_M
      ) {
        return false;
      }

      if (this.nextStatusData.IS_LOAD_FILE && !this.statusData.UF_FILE_NOTICE) {
        return false;
      }

      return true;
    },
    ...mapGetters([
      "currentUser",
      "directory",
      "project",
      "projectStatusHistory"
    ])
  },
  methods: {
    findName(list, id, r) {
      if (r) {
        return r;
      }

      list.forEach(function(l) {
        if (l.CHILD) {
          r = this.findName(l.CHILD, id, r);
        } else {
          l.TYPE_LIST_ID.forEach(function(item) {
            if (item.TYPE_ID === id) {
              r = item.NAME;
            }
          });
        }
      }, this);
      return r;
    },
    checkNewStatus() {
      this.directory.program_fin_support.forEach(async function(s) {
        if (s.ID === this.$parent.project.UF_SUPPORT_PROG_ID) {
          ProjectsService.bpStatus(
            s.UF_BP_ID,
            this.statusData.UF_STATUS_ID
          ).then(({ data }) => {
            this.nextStatusData = data[0];
            if (
              this.getStatus(this.statusData.UF_STATUS_ID).CODE === "stop_work"
            ) {
              this.nextStatusData.STOP_WORK_COM = true;
            }
            if (
              this.getStatus(this.statusData.UF_STATUS_ID).CODE ===
              "terminated_work"
            ) {
              this.nextStatusData.TERMINATED_WORK_COM = true;
            }
            /*
            if (
              this.$parent.documentConf &&
              this.getStatus(this.statusData.UF_STATUS_ID).CODE ===
                "sent_revision_enter_expertise"
            ) {
              let aFiles = [];

              Object.keys(
                this.$parent.documentConf.FILE_DOCUMENTS_PATH
              ).forEach(function(k) {
                let files = this.$parent.documentConf.FILE_DOCUMENTS_PATH[k];
                files.forEach(function(file) {
                  if (file.UF_IS_AKCEPT === 2) {
                    aFiles.push(
                      this.findName(
                        this.$parent.documentConf.LIST_TYPE,
                        file.TYPE_ID,
                        ""
                      )
                    );
                  }
                }, this);
              }, this);
              if (aFiles.length) {
                this.statusData.UF_COMMENT_STATUS_M =
                  "Список не акцептированных документов:\n - " +
                  aFiles.join("\n - ");


              }
            }

             */
          }, this);
        }
      }, this);
    },
    setNewStatus() {
      this.isSendForm = true;
      this.saveErrors = [];
      ProjectsService.setNewStatusProject(
        this.$parent.project.ID,
        this.statusData
      ).then(response => {
        if (response.data.error === false) {
          this.$parent.showChangeStatusDialog = false;
          this.$parent.fetchAboutProject();
          //this.$parent.fetchProject(0);
          //this.$router.push({ name: "Projects" });
        } else {
          this.saveErrors = response.data.errorArr;
        }
        this.isSendForm = false;
        //window.location.reload();
      }, this);


    },
    getStatus: function(id) {
      let t = this.directory.status_all.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    onChange(e) {
      let files = e.target.files;

      for (var i = 0; i < files.length; i++) {
        let file = files[i];

        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
          // Make a fileInfo Object
          let fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + " kB",
            base64: reader.result,
            file: file
          };
          this.uFile = file.name;

          this.statusData.UF_FILE_NOTICE = fileInfo.base64;
        }; // reader.onload
      } // for
    } // onChange()
  },
  watch: {
    sumApproved: function(val) {
      this.statusData.UF_SUM_APPROVED = val;
    }
  },
  name: "ChangeStatusDialog"
};
</script>

<style scoped></style>
